import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const acreportsApi = createApi({
  reducerPath: 'acreportsApi',
  baseQuery: btBaseQuery,
  tagTypes: ['ACReports'],
  keepUnusedDataFor: 10,

  endpoints: (builder) => ({
    getACReceipts: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `acreports/receipts/${cid}/${fdt}/${tdt}`
    }),
    getACReportsExpenses: builder.query<any, any>({
      query: ({ cid, fdt, tdt, heads }) =>
        `acreports/expenses/${cid}/${fdt}/${tdt}/${heads}`
    }),
    getACReportsIncomes: builder.query<any, any>({
      query: ({ cid, fdt, tdt, heads }) =>
        `acreports/incomes/${cid}/${fdt}/${tdt}/${heads}`
    }),
    getACReportsExpensesSumm: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `acreports/expenses/1/summ/${cid}/${fdt}/${tdt}`
    }),
    getACReportsExpensesCol: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `acreports/expenses/1/cols/${cid}/${fdt}/${tdt}`
    }),
    getACReportsExpensesDetails: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `acreports/expenses/1/details/${cid}/${fdt}/${tdt}`
    }),
    getACReportsOutstanding: builder.query<any, string>({
      query: (cid) => `acreports/outstanding/${cid}`
    }),
    getACReportsSuppOutstanding: builder.query<any, string>({
      query: (cid) => `acreports/suppoutstanding/${cid}`
    }),
    getACReportsProfitAndLoss: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `acreports/profitandloss/${cid}/${fdt}/${tdt}`
    }),
    getACPaymentReceipts: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `acreports/paymentreceipts/${cid}/${fdt}/${tdt}`
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACReceiptsQuery,
  useGetACReportsExpensesQuery,
  useGetACReportsIncomesQuery,
  useGetACReportsOutstandingQuery,
  useGetACReportsExpensesSummQuery,
  useGetACReportsExpensesColQuery,
  useGetACReportsExpensesDetailsQuery,
  useGetACReportsSuppOutstandingQuery,
  useGetACReportsProfitAndLossQuery,
  useGetACPaymentReceiptsQuery
} = acreportsApi;
